<div class="tile-wrapper" 
    (click)="tileClick.emit(document)"
    [class.disable-delete]="readonly$ | async"
>
    <app-base-tile
            [data]="data"
    >
        <div class="time" [class.reverse-time]="reverseTimeOrder$ | async" leading>
            <p><span>{{ startTitle$ | async }}:</span><span class="start-value">{{ document.startTime | date: timeFormat }}</span></p>
            <p><span>{{ endTitle$ | async }}:</span><span class="start-value">{{ document.endTime | date: timeFormat }}</span></p>
        </div>
        <div class="info" trailing *ngIf="{ value: readonly$ | async } as readonly">
            <div class="se-button delete-button" (click)="readonly.value ? null : onDeleteClick($event)">Delete</div>
            <div class="status-owner-info">
                <app-label class="label" [color]="labelColor" *ngIf="(currentStatusFilter$ | async) !== 'Canceled'">{{ label }}</app-label>
                <small *ngIf="showOwner$ | async" class="owner-name px--12 py--4 fw-600">{{ document.ownerFirstName }}&nbsp;{{ document.ownerLastName[0].toUpperCase() }}.</small>
            </div>
        </div>
    </app-base-tile>
</div>